/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { AdminGetChastiaSensorChartPathParameters } from 'api/actions/admin-get-chastia-sensor-chart/admin-get-chastia-sensor-chart-path-parameters';
import { AdminGetChastiaSensorChartResponse } from 'api/actions/admin-get-chastia-sensor-chart/admin-get-chastia-sensor-chart-response';

type AdminGetChastiaSensorChartQueryParameters = Record<string, any>;

/**
 * The path of the AdminGetChastiaSensorChart action.
 */
export const adminGetChastiaSensorChartActionPath = new SweetPath<keyof AdminGetChastiaSensorChartPathParameters>(
  '/admin/custom/chastia-sensor-chart/{sensorId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized AdminGetChastiaSensorChart actions.
 */
export default function createAdminGetChastiaSensorChartAction(axios: AxiosInstance) {
  return function adminGetChastiaSensorChartAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: AdminGetChastiaSensorChartPathParameters;
    query?: AdminGetChastiaSensorChartQueryParameters;
  }) {
    const path = adminGetChastiaSensorChartActionPath.insert(parameters);

    return axios.get<AdminGetChastiaSensorChartResponse, AdminGetChastiaSensorChartResponse>(path, {
      params: query,
      headers,
    });
  };
}
